import {helpers} from "vuelidate/lib/validators";

export const isCouponCodeValid = () => helpers.withParams(
    { type: 'isCouponCodeValid' },
    (value) => {
        const regexQuery = `^[a-zA-Z0-9]+$`
        const code = new RegExp(regexQuery, "i")
        return code.test(value)
    }
)